/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldOrdering } from './fieldOrdering';

export interface ReimbursementAnalysisReportRequest {
  insuranceCarrierIds?: Array<string> | null;
  financialClassIds?: Array<string> | null;
  locationIds?: Array<string> | null;
  attendingProviderIds?: Array<string> | null;
  referringProviderIds?: Array<string> | null;
  placeOfServiceCodeIds?: Array<string> | null;
  typesOfService?: Array<string> | null;
  reportingTypeIds?: Array<string> | null;
  locationTypes?: Array<string> | null;
  procedureCodeIds?: Array<string> | null;
  diagnosisCodeIds?: Array<string> | null;
  visitHeldStatus?: string | null;
  coverages?: string | null;
  dateRangeType?: string | null;
  dateRangeStart?: string;
  dateRangeEnd?: string;
  fieldOrderings?: Array<FieldOrdering> | null;
  outputFormat?: string | null;
  itemizeOptions?: string | null;
  includeOnlyBilled?: boolean;
  downloadFormat?: string | null;
}
